var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4307 9.99977L12.9607 5.15977C12.6707 4.20977 11.3307 4.20977 11.0507 5.15977L9.57069 9.99977H5.12069C4.15069 9.99977 3.75069 11.2498 4.54069 11.8098L8.18069 14.4098L6.75069 19.0198C6.46069 19.9498 7.54069 20.6998 8.31069 20.1098L12.0007 17.3098L15.6907 20.1198C16.4607 20.7098 17.5407 19.9598 17.2507 19.0298L15.8207 14.4198L19.4607 11.8198C20.2507 11.2498 19.8507 10.0098 18.8807 10.0098H14.4307V9.99977Z",
    fill: "#1EA896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGreen);
export default __webpack_public_path__ + "static/media/star-green.7dfce23ecb08e2694411ed9124d21b03.svg";
export { ForwardRef as ReactComponent };